require("./later");
module.exports = later;


//////////////////
// WEBPACK FOOTER
// ./~/later/index-browserify.js
// module id = 1432
// module chunks = 2